<template>
  <div>

    <QuizScenario :scenario="current.scenario" />

    <div
      v-if="$localized(current, 'inner_context')"
      class="text-center px-5 py-4"
    >
      {{ $localized(current, 'inner_context') }}
    </div>

    <v-card
      rounded="lg"
      class="quiz-text mx-6 mb-4 px-6 py-4 custom-elevation"
      >
      {{ $localized(current, 'text') }}
    </v-card>
  </div>
</template>

<script>
import QuizScenario from '@/components/games/quiz/QuizScenario.vue';

export default {
  name: 'QuizHome',
  components: {
    QuizScenario,
  },
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
